<script setup lang="ts">
import { useContext } from './context'
import { type WithAttributes, toHtml } from './attributes'

// #region props
const {
  uiBlockSize = '40',
  uiGap = '48 8',
  uiShrinkable = undefined,
  ...props
} = defineProps<WithAttributes<{
  ariaControls?: string
  ariaLabel?: string
  class: {
    layout?: 'layout-row'
  }
  uiBlockSize?: '24' | '40' | '48'
  uiGap?: '48 8' | '48 16' | '16'
  uiShrinkable?: boolean
}>>()
// #endregion props

useContext({ uiBlockSize })

// TODO: Implement movement with Arrow keys
</script>

<template>
  <div
    class="layout-row" :class="[
      props.class,
      $style.toolbar,
    ]"
    v-bind="toHtml<'div'>({ role: 'toolbar', ...props })"
    :ui-gap
    :ui-shrinkable
  >
    <slot />
  </div>
</template>

<style module>
  .toolbar {
    /* Align multiline and labeled controls to bottom */
    align-items: flex-end;
  }
</style>
